import React, { useState, useEffect } from "react";
// リダイレクト(認証期間切れの場合にリダイレクトするため)
import {useHistory} from "react-router-dom";

import GenericTemplate from "../../templates/GenericTemplate";
import {apollo_useStyles} from "../../atom/Apollo_styles";
import {APOLLO_GROUP_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {ApolloContext} from "../../atom/Apollo_Context";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";

import ApolloInVoiceMenuList from "../../organism/INVOICE/Apollo_InVoiceMenuList";
import ApolloInVoiceDownload from "../../organism/INVOICE/Apollo_InVoiceDownload";
// メッセージ定義
import {
  GetMessage,
  UI_INVOICE_LIST,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import {Card, Container, MenuItem, Select, TableCell, TableRow, Grid} from "@material-ui/core";
import Typography from '@material-ui/core/Typography';

import {
  Option,
  BillingReport,
} from "./InVoiceModel"

import { 
  apollo_billing_reports,
} from "../../atom/Apollo_links";

/*
    画面名：確定請求金額画面
 */
const InVoicePage: React.FC = () => {
  const classes = apollo_useStyles();
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [rows, setRows] = useState<BillingReport[]>([]);
  // ダウンロードボタン有効可否
  const [disabledButton, setDisabledButton] = useState(false);
  // リダイレクト(認証期間切れの場合にリダイレクトするため)
  const history = useHistory();
  
  // 年月選択オプション
  const initYear = new Date().getFullYear();
  const initMonth = new Date().getMonth();
  var options_year: Option[] = [];
  for (var i = initYear; i > 2010; i--) {
    var workMonth = initMonth;
    if (i !== initYear) {
      workMonth = 12;
    }
    for (var j = workMonth; j > 0; j--) {
      options_year.push({value: i * 100 + j, label: `${i}年 ${j}月`}); 
    }
  }
  const [selectYear, setSelectYear] = useState(initYear);
  const [selectMonth, setSelectMonth] = useState(initMonth);
  const [selectYearMonth, setSelectYearMonth] = useState(initYear * 100 + initMonth);

  // 運用型・予約型選択オプション
  const options_billingType: Option[] = [
    {value:1, label:"運用型広告"},
    {value:2, label:"予約型広告"},
  ]
  const [billingType, setBillingType] = useState(1);

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true,
      }
    });
    // API アカウントグループID / 年 / 月 / 運用型・予約型区分(1:運用型 2:予約型)
    const url = apollo_billing_reports + "/" + state.current.accountGroupId + "/" + selectYear + "/" + selectMonth + "/" + billingType;
    ApolloAxios.get(url).then(response => {
      if (response.data.resultCode === 0) {
        setRows(response.data.result);
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false,
          }
        });
      } else {
        console.log(response.data.message);
        setmsg({
          type: "all",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: GetMessage("0",UI_INVOICE_LIST,"E","0"),
            loading: false
          }
        });
      }
      checkRows(response.data.result);
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_INVOICE_LIST,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
      checkRows([]);
    });
  }, [selectYearMonth, billingType]);

  // 表示データの有無を判定し、ボタンを活性・非活性化する
  const checkRows = (rows: []) => {
    if (rows != null && rows.length > 0) setDisabledButton(false);
    else setDisabledButton(true);
  }

  // カラム定義
  const columns = [
    {
      name: "advertiserName",
      label: "広告主名",
      options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => {
          return {
            style: {
              width: '20%',
            },
          };
        },
      },
    },
    {
      name: "platformAccountName",
      label: "広告主アカウント名",
      options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => {
            return {
              style: {
                width: '20%',
              },
            };
          },
        },
      },
      {
      name: "menuName",
      label: "メニュー",
      options: {
          filter: false,
          sort: false,
          setCellHeaderProps: () => {
            return {
              style: {
                width: '14%',
              },
            };
          },
        },
      },
      {
      name: "campaignKindName",
      label: "キャンペーン種別",
      options: {
          filter: false,
          sort: false,
          setCellHeaderProps: () => {
            return {
              style: {
                width: '22%',
              },
            };
          },
        },
      },
      {
      name: "budgetAmount",
      label: "月額予算",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => {
          return {
            style: {
              width: '12%',
            },
          };
        },
        setCellProps: () => ({
          align: "right",
        }),
        customBodyRender: (num: number) => {
          var value = "";
          if (billingType === 1) value = "￥" + Number(num ? num : 0).toLocaleString();
          return value;
        },
      },
    },
    {
      name: "price",
      label: "確定金額",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => {
          return {
            style: {
              width: '12%',
            },
          };
        },
        setCellProps: () => ({
          align: "right",
        }),
        customBodyRender: (num: number) => {
          return "￥" + Number(num ? num : 0).toLocaleString();
        },
      },
    },
  ];

  // 年月選択ハンドラ
  const handleYearMonthChange = (event: any) => {
    var workYM = event.target.value;
    setSelectYear(parseInt(workYM / 100 + ""));
    setSelectMonth(workYM % 100);
    setSelectYearMonth(workYM);
  }

  // 運用型・予約型選択ハンドラ
  const handleBillingTypeChange = (event: any) => {
    setBillingType(event.target.value);
  }

  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: false,
    selectableRows: "none",
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    viewColumns:false,
    storageKey: STORAGE_KEY.IN_VOICE,
    // columnDefs: [
    //   // 列幅をパーセントで指定
    //   { targets: [0,1], width: ["1px"] },
    //   { targets: 0, visible: false },
    // ],
    renderExpandableRow: (rowData: any, rowMeta: { rowIndex: number, dataIndex: number }) => {
      const colspan = rowData.length + 1;
      return (
        <TableRow>
          <TableCell colSpan={colspan}>
            <ApolloInVoiceMenuList accountId={rows[rowMeta.dataIndex].accountId + ""} year={String(selectYear)} month={String(selectMonth)} billingType={billingType} />
          </TableCell>
        </TableRow>
      );
    },
  }

  return (
    <GenericTemplate title="">
      <ApolloPageUsagePermission role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Container maxWidth="xl">
          <Grid item xs={12}>
            <ApolloBreadcrumbs bread_no={56} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                              platform={""}/>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Typography variant="caption" display="block">
                <ul>
                  <li style={{listStyle:'square'}}>
                  異議申し立てがある場合、既定の営業日までに以下宛先にご連絡ください。<br/>ご連絡のない場合は、送付した金額で確定とさせていただきます。<br/>docomoad-order@cartahd.com 
                  </li>
                </ul>
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={1}>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Typography variant="button" display="block" align="left">
                    {/* 請求CSVダウンロード */}
                    <ApolloInVoiceDownload accountGroupId={state.current.accountGroupId} year={String(selectYear)} month={String(selectMonth)} billingType={billingType} disabledButton={disabledButton} />
                    {/* 運用型・予約型選択 */}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Select
                    labelId="billingType"
                    id="billingType"
                    name="billingType"
                    value={billingType}
                    onChange={handleBillingTypeChange}
                    fullWidth={true}
                  >
                    {options_billingType.map(options_billingType => (
                      <MenuItem value={options_billingType.value}>{options_billingType.label}</MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  {/* 年月選択 */}
                  <Select
                    labelId="yearMonth"
                    id="yearMonth"
                    name="yearMonth"
                    value={selectYearMonth}
                    onChange={handleYearMonthChange}
                    fullWidth={true}
                  >
                    {options_year.map(option_year => (
                      <MenuItem value={option_year.value}>{option_year.label}</MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* テーブル表示 */}
          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              title=""
              data={rows}
              columns={columns}
              options={
                {
                  ...options,
                  textLabels:{
                    body: {noMatch: "該当データが存在しません"}
                  },
                }
              }
            />
          </Card>
        </Container>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
}

export default InVoicePage;
